<template>
  <div
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-input">
      <div class="m-file-wap" v-if="!fieldObj.value">
        <div class="u-upload-tips">
          <i class="icontemp jia"></i>
          <span :class="{disabled: fieldObj.disabled}">点击添加图片</span>
        </div>
        <input
          type="file"
          class="file-input"
          :class="{disabled: fieldObj.disabled}"
          title=""
          @change="changeFile"
          :accept="fieldObj.accept"
          :value="fieldObj.value ? '' : null"
          :disabled="fieldObj.disabled"
        />
      </div>

      <div class="m-file-wap m-file-img" v-if="fieldObj.value">
        <img :src="fieldObj.value ? fieldObj.value.newPath : ''" />
        <div class="u-delete-icon" @click="clearFile">
          <span class="icontemp stemp-close"></span>
        </div>
      </div>
    </div>
    <div class="u-reg-item-tips-wap">图片大小限制：5M</div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import imgMixin from "../../field/new-fields/img";
export default {
  name: "sk-img-wap",
  mixins: [imgMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
</style>
